// extracted by mini-css-extract-plugin
export default {"root":"DateInput_root__hbOwk","fullWidth":"DateInput_fullWidth__AP2xK"};